export const FETCH_PROFILE_DETAILS_REQUEST = "FETCH_PROFILE_DETAILS_REQUEST";
export const FETCH_PROFILE_DETAILS_FAILURE = "FETCH_PROFILE_DETAILS_FAILURE";
export const FETCH_PROFILE_DETAILS_SUCCESS = "FETCH_PROFILE_DETAILS_SUCCESS";

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
